import React, { Component } from 'react'
import fetch from 'isomorphic-fetch'

import AcervoLayout from '../../../templates/acervo'
import Project from '../../components/Sections/Detail/Project'
import Agency from '../../components/Sections/Detail/Agency'
import Headline from '../../components/Sections/Detail/Headline'
import Goals from '../../components/Sections/Detail/Goals'
import Expenses from '../../components/Sections/Detail/Expenses'
import Paginator from '../../components/UI/Paginator/Paginator'
import { ACERVO_URL } from '../../../store/config'
import DetailHeader from '../../components/Sections/Detail/DetailHeader'


class AcervoDetail extends Component {

    state = {
        project: {},
        pagination: {
            itemsCountPerPage: 1,
            activePage: 1,
            totalItemsCount: 5
        },
    }

    componentDidMount() {
        const { access_token } = this.props.session.user.profile,
            id = this.props.match.params.id

        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${access_token}`
            },
            method: 'get'
        };

        const url = new URL(`${ACERVO_URL}/projects/${id}`)

        fetch(url, options)
            .then(result => {
                if (result.status >= 200 && result.status < 300) {

                    return result.json();
                } else {
                    return result.json().then(Promise.reject.bind(Promise));
                }
            })
            .then(response => {
                this.setState({ project: response })
            })
            .catch(console.log)
    }

    handlerChangePage = page => {
        let pagination = Object.assign({}, this.state.pagination)
        pagination['activePage'] = page
        this.setState({ pagination })
    }

    renderPage = page => {
        const { project } = this.state

        if (Object.keys(project).length === 0)
            return <p>No hay información para mostrar</p>

        switch (page) {
            case 1:
                return <Project project={project} />
            case 2:
                return <Agency agency={project.agency} />
            case 3:
                if (project.titular === undefined || project.titular === null)
                    return <p>No hay información para mostrar</p>
                return <Headline headline={project.titular} />
            case 4:
                if (project.goals.length === 0)
                    return <p>No hay información para mostrar</p>
                return <Goals goals={project.goals} />
            case 5:
                if (project.expenses.length === 0)
                    return <p>No hay información para mostrar</p>
                return <Expenses expenses={project.expenses} />
            default:
                break;
        }
    }

    render() {
        const { itemsCountPerPage, totalItemsCount, activePage } = this.state.pagination

        const TitlePage = {
            1: 'Detalles del proyecto',
            2: 'Detalles de la agencia',
            3: 'Detalles del titular',
            4: 'Detalles de las metas',
            5: 'Detalles de los gastos'
        }

        return (
            <div className="columns is-multiline is-centered acervo-detail">

                <div className="column is-10">
                    <DetailHeader title={TitlePage[activePage]} />
                    {this.renderPage(activePage)}
                </div>

                <div className="column is-12">
                    <Paginator
                        itemsCountPerPage={itemsCountPerPage}
                        totalItemsCount={totalItemsCount}
                        activePage={activePage}
                        onChange={this.handlerChangePage}
                    />
                </div>
            </div>
        )
    }
}

export default AcervoLayout(AcervoDetail, {
    title: 'Acervo',
    subnav: {
        icon: 'fa-briefcase',
        name: 'Acervo',
        actions: [
        ]
    },
    stateNav: false,
    progress: false
})


// WEBPACK FOOTER //
// ./src/acervo/containers/Detail/Detail.js